import { render } from "./not-found.vue?vue&type=template&id=28119fb0&scoped=true&ts=true"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"

import "./not-found.vue?vue&type=style&index=0&id=28119fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28119fb0"],['__file',"src/components/not-found.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28119fb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28119fb0', __exports__)) {
    api.reload('28119fb0', __exports__)
  }
  
  module.hot.accept("./not-found.vue?vue&type=template&id=28119fb0&scoped=true&ts=true", () => {
    api.rerender('28119fb0', render)
  })

}


export default __exports__